/**
 * KI-WARNGRENZEN — EINE QUELLE FUER ALLE KI-FUELLSTANDSANZEIGEN (Rafael, 03.10.2026 16:42:
 * „gelb ab 80 %, rot ab 95 % — überall gleich"). Bis dahin hatte jede Anzeige eigene Zahlen
 * (Menue-Balken und CC-Usage 50/80, Capacity 60/85, Sammelanzeiger 90, KI-Leiste 80/95).
 * Gilt fuer das Kontingent der KI-Zugaenge (Woche/Kurzzeit), nicht fuer Speicher, Testabdeckung o. ae.
 * Unbekannt (null) bleibt gedaempft, nie gruen — eine 0 saehe aus wie „frei".
 */
/** Ab hier gelb/bernstein („hoch"). */
export const KI_GELB_AB = 80;
/** Ab hier rot („knapp"). */
export const KI_ROT_AB = 95;

/** Farbe eines KI-Fuellstands: gruen, bernstein ab 80 %, rot ab 95 %; unbekannt gedaempft. */
export function kiFuellFarbe(p: number | null | undefined): string {
  if (p === null || p === undefined || !Number.isFinite(p)) return 'var(--tn-text-muted)';
  if (p >= KI_ROT_AB) return 'var(--tn-red)';
  if (p >= KI_GELB_AB) return 'var(--tn-orange)';
  return 'var(--tn-green)';
}
